module.exports = __webpack_public_path__ + "img/ios1-min.jpg";